import { LitElement, html, unsafeHTML, css, unsafeCSS } from '@hh/global.js'

var myHeaders = new Headers()
myHeaders.append('Content-Type', 'application/graphql')

export class HHPaletteSwatches extends LitElement {
  static properties = {
    cardsHtml: { type: String },
    dataIndex: { type: String }
  }

  constructor() {
    super()
    this.cardsHtml = ''
    this.dataIndex = '01'

    this.metaobjectIDs = this.getAttribute('data-metaobject-ids')
    this.api = this.getAttribute('data-storefront-api')
    this.url = this.getAttribute('data-storefront-url')

    myHeaders.append('X-Shopify-Storefront-Access-Token', `${this.api}`)
    this.getMetaobjectsData(this.metaobjectIDs)
    document.querySelector('virtual-try-on').setAttribute('data-color', this.dataIndex)
  }

  connectedCallback() {
    super.connectedCallback()
  }

  async getImageViaGID(gid) {
    var raw = `query {
      node(id: "${gid}") {
        id
        ... on MediaImage {
          image {
            url (transform:{maxHeight: 300, maxWidth: 300})
          }
        }
      }
    }`

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    const response = await fetch(
      `https://${this.url}/api/2023-07/graphql.json`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        const {
          data: {
            node: { image: url },
          },
        } = result

        return url
      })
      .catch((error) => console.log('error', error))

    return response.url
  }

  async getMetaobjectsData(gids) {
    const ids = JSON.stringify(gids.split(','))

    var raw = `query {
      nodes(ids: ${ids}) {
        id
        ... on Metaobject {
          handle
          type
          fields {
            key
            value
          }
        }
      }
    }`

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    const response = await fetch(
      `https://${this.url}/api/2023-07/graphql.json`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        const {
          data: { nodes },
        } = result

        return nodes
      })
      .catch((error) => console.log('error', error))
    this.generateSwatches(response)
  }

  formatNumber(number) {
    return String(number).padStart(2, '0')
  }

  async swatchTemplate(index, name, image, isActiveClass) {
    const imageUrl = await this.getImageViaGID(image)
    let formattedNumber = this.formatNumber(index + 1)
    return html`<div
      class="palette__swatch ${isActiveClass}"
      data-index="${formattedNumber}"
      data-name="${name}"
      @click="${(e) => {
        this.selectColor(e, true)
      }}"
    >
      <div class="palette__swatch--image">
        <img srcset="${imageUrl}" src="${imageUrl}" loading="lazy" />
      </div>
    </div>`
  }

  async generateSwatches(data) {
    const _this = this
    const swatches = data.map((swatch) => {
      let swatchesData = {}
      swatch.fields.forEach((field) => {
        swatchesData[field.key] = field.value
      })
      return swatchesData
    })

    const _cardsTemplate = Promise.all(
      swatches.map(async (swatch, index) => {
        const isActiveClass = index === 0 ? 'is-active' : '';

        return await _this.swatchTemplate(
          index,
          swatch.swatch_name,
          swatch.image,
          isActiveClass
        )
      })
    )

    const cardsTemplate = await _cardsTemplate
    this.cardsHtml = cardsTemplate
  }

  selectColor(e, isSwatch = false) {
    if (isSwatch) {
      const clickedSwatch = e.target.closest('.palette__swatch');

      this.renderRoot
        .querySelectorAll('.palette__swatch')
        .forEach((el) => el.classList.remove('is-active'));

      clickedSwatch.classList.add('is-active');
      this.dataIndex = clickedSwatch.getAttribute('data-index')
      document.querySelector('virtual-try-on').setAttribute('data-color', this.dataIndex)
    }
  }

  render() {
    return html`
      <div class="palette__wrapper js-palette-swatches">
        <div class="palette__swatches">
          ${this.cardsHtml?.map((card) => { return card })}
        </div>
      </div>
    `
  }

  static styles = css`
    .palette__wrapper {
      max-width: 1280px;
      margin: 0 auto;
    }

    .palette__swatches {
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      justify-content: center;
    }

    .palette__swatch {
      width: calc(100% / 10);
      cursor: pointer;
    }

    @media screen and (min-width: 750px) {
      .palette__swatch {
        width: calc(100% / 18);
      }
    }

    .palette__swatch--image > img {
      width: calc(100% - 10px);
      max-width: 180px;
      height: auto;
      border-radius: 100%;
      border: 2px solid transparent;
      padding: 3px;
    }

    .palette__swatch.is-active .palette__swatch--image > img {
      border: 2px solid #000;
    }

    @media screen and (max-width: 749px) {
      .palette__wrapper {
        position: absolute;
        top: 0;
        left: 2rem;
        right: 2rem;
      }
    }
  `
}

customElements.define('hh-palette-swatches', HHPaletteSwatches)
